module.exports = __webpack_public_path__ + "static/media/whiteAssessments.e8b5f4f7.svg";